import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { DeckUI } from '@seedlang/state';
import { flexCenterColumn, flexCenter } from '@seedlang/style_mixins';
import { pixify } from '@seedlang/utils';
import Text from 'components/text';
import IntroCardWords from 'components/card/intro_card_words';
import NextButton from 'components/trivia_card/next_button';
import StickerReaction from 'components/sticker_reaction';
import { Theme } from '@seedlang/constants';

const Wrapper = styled.div`
  ${flexCenterColumn()}
  height: ${props => props.height};
  position: relative;
  background: #333;
`;

const Content = styled.div`
  flex: 1;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const Header = styled.div`
  ${flexCenter()}
  margin: 20px 0;
`;

const Title = styled.div`
  ${flexCenterColumn()}
  color: white;
`;

@observer
class CaseIntroCard extends React.Component {

  render() {
    return (
      <Wrapper
        height={pixify(DeckUI.layout.contentHeightWithoutButtons)}
        width={pixify(DeckUI.layout.deckWidth)}
      >
        <Content>
          <Header>
            <Title>
              <Text
                heading='2'
                color='white'
                textAlign='center'
                margin='20px 0'
              >
                CASE TRAINER
              </Text>
              <StickerReaction
                width='120px'
                reaction='happy'
                languageId={DeckUI.targetLanguageId}
                borderColor={Theme.green}
                background={Theme.blue}
              />
            </Title>
          </Header>
          <IntroCardWords
            title="Nouns You'll Encounter in this Deck"
            deck={DeckUI.deck}
            user={DeckUI.user}
            layout={DeckUI.layout}
          />
        </Content>
        <NextButton
          disabled={!this.props.inView}
          onClick={() => DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard)}
          shortcut='1'
          submitOnEnter
          text='Start Practice'
          margin='10px 0'
        />
      </Wrapper>
    );
  }
}

export default observer(CaseIntroCard);